// extracted by mini-css-extract-plugin
export default {"root":"SubLayout_root__eT2yw","body":"SubLayout_body__L43B0"};